import { Link } from "react-router-dom";
import { pub } from "../lib/pubThemeClasses";
import { useLanguage } from "../context/LanguageContext";

export default function NotFound() {
  const { t } = useLanguage();
  return (
    <section className="min-h-[70vh] grid place-items-center px-6">
      <div className="text-center space-y-6">
        <div className="font-mono text-xs uppercase tracking-[0.25em] text-[#FF4F00]">{t("notfound.label")}</div>
        <h1 className={`font-display text-5xl md:text-7xl font-black uppercase tracking-tight ${pub.heroHeading}`}>{t("notfound.title")}</h1>
        <p className={`max-w-lg mx-auto ${pub.muted}`}>{t("notfound.body")}</p>
        <Link
          to="/"
          data-testid="notfound-home-link"
          className="inline-block bg-[#FF4F00] hover:bg-[#E64700] text-black font-bold uppercase tracking-wider text-sm px-6 py-4"
        >
          {t("notfound.home")}
        </Link>
      </div>
    </section>
  );
}
